import styled from '@emotion/styled';
import { Button } from 'antd';
import { colorConstants } from 'config/colorConstants';

export const StyledFilterPanelsRoot = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 3px;
`;

export const StyledPanel = styled.div`
    display: flex;
    width: 317px;
    padding: 16px 0;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    border-radius: 12px;
    border: 1px solid ${colorConstants.tableColorSplit};
    background: ${colorConstants.white};
    box-shadow: ${colorConstants.modalContentShadow};

    .filter-panel-section {
        width: 100%;
    }

    .filter-panel-header {
        display: flex;
        align-items: center;
        gap: 4px;
        width: 100%;
    }

    .filter-panel-title-wrap {
        flex: 0 0 108px;
        width: 108px;
        padding: 0 16px;
    }

    .filter-panel-title {
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        color: ${colorConstants.blackTransparent88};
        margin: 0;
        white-space: nowrap;
    }

    .filter-panel-search {
        flex: 1 1 0;
        min-width: 0;
        padding: 0 16px;
    }

    .filter-panel-search-group {
        display: flex;
        align-items: stretch;
        width: 100%;
        height: 32px;
        border-radius: 6px;
        border: 1px solid ${colorConstants.greyAlt};
        background: ${colorConstants.white};
        overflow: hidden;
    }

    .filter-panel-search-input.ant-input {
        flex: 1;
        min-width: 0;
        height: 100%;
        border: none;
        box-shadow: none;
        border-radius: 6px 0 0 6px;
        padding: 4px 11px;
        font-size: 14px;
        line-height: 22px;
        background: transparent;

        &::placeholder {
            color: ${colorConstants.greyAlt12};
        }

        &:hover,
        &:focus {
            border: none;
            box-shadow: none;
        }
    }

    .filter-panel-search-button {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 32px;
        height: 100%;
        border: 0;
        border-left: 1px solid ${colorConstants.greyAlt};
        border-radius: 0 6px 6px 0;
        background: ${colorConstants.white};
        padding: 0;
        cursor: pointer;
        transition: border-color 0.15s ease;

        .anticon {
            font-size: 16px;
            line-height: 1;
            color: ${colorConstants.blackTransparent88};
            transition: color 0.15s ease;
        }
    }

    .filter-panel-divider-wrap {
        width: 100%;
        padding: 0px 16px;
    }

    .filter-panel-divider.ant-divider,
    .filter-panel-inner-divider.ant-divider {
        margin: 0;
        border-top-color: ${colorConstants.greyAlt6};
    }

    .filter-panel-show-only-scroll,
    .filter-panel-categories-scroll {
        width: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 0 24px 0 4px;
    }

    .filter-panel-categories-scroll {
        max-height: 170px;
    }

    .filter-show-only-section {
        display: flex;
        flex-direction: column;
    }

    .filter-show-only-label {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: ${colorConstants.colorTextDescription};
        padding: 0 12px 8px;
        margin: 0;
    }

    .filter-show-only-item-label {
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: ${colorConstants.blackTransparent88};
    }

    .filter-menu-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 12px;
        border-radius: 4px;
        cursor: pointer;
        transition: background 0.15s ease;

        &.active {
            background: ${colorConstants.grey};
        }

        &:hover:not(.active) {
            background: ${colorConstants.greyAlt9};
        }

        .filter-menu-item-left {
            display: flex;
            align-items: center;
            gap: 8px;
            height: 22px;
        }

        .filter-category-label {
            font-size: 14px;
            line-height: 22px;
            font-weight: 400;
            color: ${colorConstants.blackTransparent88};
        }

        .filter-category-label-active {
            font-weight: 500;
            color: ${colorConstants.violet};
        }

        .filter-menu-chevron {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 12px;
            height: 12px;
            flex-shrink: 0;
        }

        .ant-switch {
            min-width: 28px;
            height: 16px;
            line-height: 16px;
            box-shadow: none;

            &:focus,
            &:focus-visible,
            &:focus-within {
                box-shadow: none;
                outline: none;
            }

            .ant-switch-handle::before {
                box-shadow: none;
            }
        }

        .ant-switch .ant-switch-handle {
            width: 12px;
            height: 12px;
        }

        .ant-switch.ant-switch-checked .ant-switch-handle {
            inset-inline-start: calc(100% - 14px);
        }
    }

    .filter-categories-section {
        display: flex;
        flex-direction: column;
    }

    .ant-switch.ant-switch-checked {
        background: ${colorConstants.violet};
        box-shadow: none;
    }

    .ant-switch.ant-switch-checked:hover:not(.ant-switch-disabled) {
        background: ${colorConstants.purpleFontSelected};
        box-shadow: none;
    }

    .ant-switch:not(.ant-switch-checked) {
        box-shadow: none;
    }
`;

export const StyledFilterPanelFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 16px;
`;

export const StyledFilterPanelFooterActions = styled.div`
    display: flex;
    flex: 1 1 0;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    min-width: 0;
`;

const filterFooterButtonBase = `
    &.ant-btn {
        height: 32px;
        padding: 0 15px;
        border-radius: 6px;
        font-size: 14px;
        line-height: 22px;
        font-weight: 600;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        &:focus,
        &:focus-visible {
            outline: none;
        }
    }
`;

export const StyledFilterResetButton = styled(Button)`
    ${filterFooterButtonBase}

    &.ant-btn {
        border: 1px solid ${colorConstants.greyAlt};
        background: ${colorConstants.white};
        color: ${colorConstants.blackTransparent88};
        box-shadow: 0 2px 0 0 ${colorConstants.controlTmpOutline};

        &:hover,
        &:focus {
            border-color: ${colorConstants.greyAlt};
            background: ${colorConstants.white};
            color: ${colorConstants.blackTransparent88};
            box-shadow: 0 2px 0 0 ${colorConstants.controlTmpOutline};
        }
    }
`;

export const StyledFilterApplyButton = styled(Button)`
    ${filterFooterButtonBase}

    &.ant-btn.ant-btn-primary {
        border: 1px solid ${colorConstants.violet};
        background: ${colorConstants.violet};
        color: ${colorConstants.white};
        box-shadow: 0 2px 0 0 ${colorConstants.controlOutline};

        &:hover,
        &:focus {
            background: ${colorConstants.purpleFontSelected} !important;
            border-color: ${colorConstants.purpleFontSelected} !important;
            color: ${colorConstants.white} !important;
            box-shadow: 0 2px 0 0 ${colorConstants.controlOutline};
        }
    }
`;
